export const titleText = 'BeeHero';
export const expiredLinkText = 'This link has been expired';
export const weSentYouAnEmailText = "We've sent you an email";
